<div class="dashboard-material-theme switch-intervention" fxLayout="column" fxLayoutAlign="center center">
  <div class="header">
    <h1>
      Are you sure you would like to move the <br />
      participant to from their current intervention?
    </h1>
  </div>

  <div class="container">
    <p>
      This is only possible before the participant has started answering.<br />
      After they begin, it is no longer possible to change their intervention.
    </p>

    <div class="buttons">
      <button (click)="cancel()">Cancel</button>

      <button class="confirm" (click)="save()">Yes</button>
    </div>
  </div>
</div>
